import React from "react";

import { Alert, Button, Col, Input, message, Popover, Row } from "antd";

import { _getOrderStatus } from "../../services";

class DeliveryDiscount extends React.Component{

    constructor(props){
        super(props);

        this.state = {

            discountAmount: 0,  
            orderStatus: false,

            loading: true,
            popoverIsOpen: false

        };
    }

    componentDidMount(){

        _getOrderStatus({ cartId: this.props.cartId })
            .then( res => {

                const orderStatus = res.data.orderStatus;

                this.setState({
                    loading: false,
                    orderStatus
                });

            })
            .catch( e => {

                message.error(e.toString());

            })

    }

    render(){

        return(

            <Popover 
                visible={ this.state.popoverIsOpen }
                title={"Delivery Discount"} 
                content={ this.renderDeliveryDiscountPopover() }>

                <Button 
                    loading={this.state.loading} 
                    onClick={ this.onClickDeliveryDiscount } 
                    type="danger">

                    Delivery Discount
                    {this.state.popoverIsOpen}

                </Button>

            </Popover>
        );

    }

    renderDeliveryDiscountPopover(){

        return(
            <div>

                <Alert message="This action is not reversible" type="warning" showIcon />
                <br/>

                <h3>Delivery Charged: SGD 5.50</h3>
                <h3>Total Delivery Refunded: SGD 0.00</h3>
                
                <Row type="flex" gutter={8}>
                    <Col>
                        <h3>Amount to Refund: </h3>
                    </Col>
                    <Col>
                        <Input 
                            onChange={ this.onChangeDiscountAmount }
                            type="number" 
                            placeholder={"5.50"} 
                            style={{ width: 100 }}/>
                    </Col>
                </Row>
                <br/>

                <Row type="flex" justify="end" gutter={8}>
                    <Col>
                        <Button 
                            onClick={ this.onClickCancel }
                            type="ghost">
                            Cancel
                        </Button>
                    </Col>
                    <Col>
                        <Button 
                            onClick={ this.onClickConfirmDiscount }
                            disabled={ this.getConfirmDiscountButtonIsDisabled() } 
                            type="danger">
                            Confirm Discount
                        </Button>
                    </Col>
                </Row>
            </div>
        )

    }

    getConfirmDiscountButtonIsDisabled = () => {
    
        // if amount is 0
        if( this.state.discountAmount === 0 ){
            return true;
        }

        if( this.state.discountAmount > this.getMaxAmountEligibleForDiscount()){
            return true;
        }

        if( !this.state.discountAmount ){
            return true;
        }

        return false;

    }

    getMaxAmountEligibleForDiscount = () => {

        // let amountAlreadyDiscounted = 0;
        // let amountChargedForDelivery = 0;

        // // if discount amount > amount charged for delivery
        // if( this.state.discountAmount + amountAlreadyDiscounted > amountChargedForDelivery ){
        //     return true;
        // }

        return 20;
    }

    onChangeDiscountAmount = ( e ) => {
        
        let tmpAmount = parseFloat( e.target.value );

        if( tmpAmount === 0 ){
            message.error("Amount must be > 0");
        }

        if( !tmpAmount ){
            message.error("Amount not be blank or contain alphabets!")
        }

        let maxAmountEligibleForDiscount = this.getMaxAmountEligibleForDiscount();
        if( tmpAmount > maxAmountEligibleForDiscount ){
            message.error(`Max amount eligible for discount is ${maxAmountEligibleForDiscount}`);
        }

        this.setState({
            discountAmount: tmpAmount
        })

    }

    onClickCancel = () => {

        this.setState({
            popoverIsOpen: false
        });

    }

    onClickConfirmDiscount = () => {

    }

    onClickDeliveryDiscount = () => {

        this.setState({
            popoverIsOpen: true
        });

    }

}

export default DeliveryDiscount;


// WEBPACK FOOTER //
// ./src/components/orders-v3/delivery-discount-button.js